import { useQuery } from "react-query";
import { feedbacks } from "../../api/feedbacks";
import { useGlobalStore } from "../../store";

export const useFeedbacksStatistics = (formId: number) => {
  const selectedCompany = useGlobalStore(state => state.selectedCompany);
  return useQuery(
    ["feedbacks-statistics", formId, selectedCompany],
    () => feedbacks.listStatistics(formId, selectedCompany),
    {
      retry: false,
      refetchOnWindowFocus: false,
    },
  );
};
